export default {
    isToggled : false
};


// WEBPACK FOOTER //
// ./src/modules/account-connector/components/proof-of-ownership-mobile/initialState.js